
/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const ip = {
    index: 		r => require.ensure([], () => r(require('./components/index')), 'ip'),
    announcementIp: 		r => require.ensure([], () => r(require('./components/announcement_ip')), 'ip')
 };
export default [
  {
      name: 'ip.index',
      path: '/ip-information/campaign',
      component: ip.index,
  },
  {
      name: 'ip.announcementIp',
      path: '/ip-information/announcement',
      component: ip.announcementIp,
  }
   
]


// WEBPACK FOOTER //
// ./src/app/ip/routes.js